import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import EfSection from '@elem/ui/ef-section';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { t } = useLang('theProduct.M');
    const [gap, setGap] = useState(24);

    const lists = [
        {
            tab: t('tab1_title'),
            desc: t('tab1_desc'),
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154864567/4_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079029541/M-pc-1.jpg',
            desktop: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155077882/4_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079215379/M-d-1.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155005457/4_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079577738/M-pad-1.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155047846/4_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079576856/M-h5-1.jpg',
        },
        {
            tab: t('tab2_title'),
            desc: t('tab2_desc'),
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154864920/4_2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079029964/M-pc-2.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155005996/4_2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079577563/M-pad-2.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155048362/4_2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079578120/M-h5-2.jpg',
        },
        {
            tab: t('tab3_title'),
            desc: t('tab3_desc'),
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154864730/4_3.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079030143/M-pc-3.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155005830/4_3.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079577386/M-pad-3.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155048184/4_3.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079577947/M-h5-3.jpg',
        },
        {
            tab: t('tab4_title'),
            desc: t('tab4_desc'),
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154865101/4_4.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079029738/M-pc-4.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155005640/4_4.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079577206/M-pad-4.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741155048010/4_4.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741079577029/M-h5-4.jpg',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 20 : window?.innerWidth >= 768 ? 48 : 0);
        }
    }, []);

    return (
        <div className={styles.TheComp}>
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfSwiperTab theme="white" loop navigation={false} pagination={false} lists={lists} gap={gap} />
        </div>
    );
}
